module.exports = __webpack_public_path__ + "img/logo-ups.6a60a2fe.svg";